<template>
  <div class="container">
    <!-- <form action="/">
      <van-search
        v-model="value"
        placeholder="请输入你要搜索的内容"
        shape="round"
        @search="onSearch"
      />
    </form> -->
    <!-- <div class="img_video" v-for="item in list" :key="item.id">
      <a @click="goVideo2(item.id)">
        <img class="imgWebSoketDomain" :src="item.src" />
        <div class="video_title">{{ item.name }}</div>
      </a>
    </div> -->
    <div class="title-top">
      <img src="@assets/images/txt.png" alt="" />
      <span>视频列表</span>
    </div>
    <div class="main-dif" v-for="item in list" :key="item.id">
      <div class="same fl" @click="goVideo2(item.id)">
        <img :src="item.src" alt="" />
        <p>{{ item.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getVideoData } from "@api/common";
import { getSearchData } from "@api/common";
import { baseInfo } from "@utils/config.js";

export default {
  data() {
    return {
      list: [],
      currentId: 1,
      info: [],
      value: ""
    };
  },
  created() {
    this.getDataInfo();
  },
  methods: {
    // 获取整体数据
    getDataInfo() {
      getVideoData().then(res => {
        console.log(res);
        if (res.status === 200) {
          this.list = res.data;
          console.log(this.list);
        } else {
          console.log(res.msg);
        }
      });
    },
    // 模糊查询
    onSearch() {
      // console.log(this.value);
      getSearchData({ keyword: this.value }).then(res => {
        // console.log(res);
        this.list = res.data;
      });
    },
    // 跳转子视频
    goVideo2(id) {
      this.$router.push({ path: "/video2", query: { lid: id } });
    }
  },
  computed: {
    getWebSoketDomain() {
      return baseInfo.webSoketDomain;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 0.25rem;
  // background-color: #fff;
  height: 100%;
  .title-top {
    margin-top: 0.2rem;
    img {
      width: 3.5%;
      height: 1.6%;
      vertical-align: bottom;
    }
    span {
      color: #3bbb61;
      font-size: 0.25rem;
      margin-left: 0.1rem;
    }
  }
  .same {
    width: 47%;
    height: 2rem;
    margin-top: 0.33rem;
    margin-right: 0.2rem;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    p {
      color: #fff;
      font-size: 16px;
      background-color: rgba(0, 0, 0, 0.5);
      text-align: center;
      font-family: SourceHanSansCN-Regular;
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
  .fl {
    float: left;
  }
  .one {
    width: 60%;
    height: 2rem;
  }
  .two {
    width: 37%;
    height: 2rem;
  }
  .three {
    width: 47%;
  }
}
// .img_video {
//   width: 6.8rem;
//   height: 2.5rem;
//   margin: 0 auto;
//   margin-top: 18px;
//   position: relative;
//   .imgWebSoketDomain {
//     width: 100%;
//     height: 100%;
//   }
//   .video_title {
//     border-top: 1px solid #fff;
//     border-bottom: 1px solid #fff;
//     font-size: 0.3rem;
//     color: #fff;
//     position: absolute;
//     height: 0.8rem;
//     line-height: 0.8rem;
//     top: 36%;
//     left: 50%;
//     transform: translate(-50%);
//     padding: 0 0.3rem;
//   }
// }
.van-search {
  input {
    padding-top: 5px;
  }
}
</style>
